var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F37D53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3892_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0778 33H26.9108M33 33H32.833M21.167 33H21M27.0778 28H26.9108M33 28H32.833M21.167 28H21",
    stroke: "#F37D53",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.3958H38M32.2425 19.6515V16.0625M21.7575 19.6515V16.0625M19.8494 38.0625H34.1506C36.2766 38.0625 38 36.4161 38 34.3852V21.5731C38 19.5422 36.2766 17.8958 34.1506 17.8958H19.8494C17.7234 17.8958 16 19.5422 16 21.5731V34.3852C16 36.4161 17.7234 38.0625 19.8494 38.0625Z",
    stroke: "#F37D53",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3892_444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadline);
export default __webpack_public_path__ + "static/media/Deadline.8937117ce5a48ccbf94194477d6d5a54.svg";
export { ForwardRef as ReactComponent };